import React, { FC, createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { sleep } from '../utils/sleep';

const extractDefault = {
  cpf: '',
  setCpf: () => '',
};

export interface ContextExtract {
  cpf: string;
  setCpf: (cpf: string) => void;
}

const ExtractContext = createContext<ContextExtract>(extractDefault);

const ExtractProvider: FC<{ children: JSX.Element }> = ({ children }) => {
  const [cpf, setCpf] = useState<string>('');

  const [searchParams] = useSearchParams();

  const page = searchParams.get('p');

  const urlCpf = searchParams.get('cpf');

  const isExtractPage = useCallback(async () => {
    if (page === 'extrato-beneficiario' || page === 'perfil-colaborador') {
      await sleep(1000);

      return window.postMessage({ type: 'URL_CHANGE', isExtractPage: true, cpf: cpf || urlCpf }, '*');
    }

    return window.postMessage({ type: 'URL_CHANGE', isExtractPage: false, cpf: '' }, '*');
  }, [page, cpf, urlCpf]);

  useEffect(() => {
    isExtractPage();
  }, [isExtractPage]);

  const value = useMemo(
    () => ({
      cpf,
      setCpf,
    }),
    [cpf],
  );

  return <ExtractContext.Provider value={value}>{children}</ExtractContext.Provider>;
};

const useExtract = () => {
  const extract = useContext(ExtractContext);

  if (!extract) {
    throw new Error('Cannot use `useExtract` outside of ExtractProvider');
  }
  return extract;
};

export { ExtractContext, ExtractProvider, useExtract };
